// todo move this file to module
export let ChatActivityOptions = {
    '1': 'فعال',
    '0': 'غیرفعال',
}